"use client";

import { ErrorState } from "@/components/errorState/ErrorState";
import { RenderError } from "@/types/defs/errorState";

// Scopes a marketing/FAQ page crash to the content area — the header and footer above this boundary stay alive.
export default function MarketingError({
  error,
  reset,
}: {
  error: RenderError;
  reset: () => void;
}) {
  return <ErrorState error={error} reset={reset} boundary="marketing" />;
}
